import { ArticleContentTypeEnum } from '@typing/Generated';

type ThingWithContentType = {
  contentType: ArticleContentTypeEnum;
};

export const articleUrlPrefix = (article: ThingWithContentType) => {
  if (article.contentType === ArticleContentTypeEnum.text || article.contentType === ArticleContentTypeEnum.video) {
    return 'articles';
  }
  if (article.contentType === ArticleContentTypeEnum.my_story) {
    return 'my-stories';
  }
  return 'webinars';
};

type ThingWithContentTypeAndWebinarCompleted = {
  contentType: ArticleContentTypeEnum;
  webinarCompleted: boolean | null;
};

export const articleHasVideo = (article: ThingWithContentTypeAndWebinarCompleted) => {
  if (article.contentType === ArticleContentTypeEnum.video || article.contentType === ArticleContentTypeEnum.my_story) {
    return true;
  }

  if (article.contentType === ArticleContentTypeEnum.webinar && article.webinarCompleted) {
    return true;
  }

  return false;
};
